import { connect } from 'react-redux'
import { TIMELINE } from '@constants/timeline_view_modes.js'
import { actions as selectableActions, selectors as selectableSelectors } from '@features/selectable/index.js'
import TimelineSizeSelector from '@components/timelines/timeline_size_selector.jsx'

const mapStateToProps = (state, props) => {
  const { namespace, scope } = props

  const viewType = selectableSelectors.getValue(state, { namespace, scope: 'viewType' })
  const allowFullscreenControl = viewType === TIMELINE

  const viewSize = selectableSelectors.getValue(state, { namespace, scope: 'viewSize' })

  return {
    namespace,
    scope,
    viewSize,
    allowFullscreenControl,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChange: (namespace, scope, size) => {
      const payload = {
        namespace,
        scope,
        value: size,
      }
      dispatch(selectableActions.changeValue(payload))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineSizeSelector)
